import { makeStyles, createStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { SmallSectionHeader } from 'components/Typography';

const ModalWrapper = styled.div`
  position: relative;
  &:focus {
    outline: none;
  }
`;
const StyledImg = styled.img`
  position: absolute;
  right: 10px;
  top: -30px;
  cursor: pointer;
`;

const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    position: absolute;
    left: 6px;
    top: -36px;
    font-weight: 300;
    color: #fff;
  }
`;

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    Backdrop: {
      background: 'rgba(0,0,0,0.6)',
    },
  }),
);

export { ModalWrapper, StyledImg, StyledSmallSectionHeader, useStyles };
